var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNetwork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.97963 4.28651C8.99305 4.19294 9 4.09728 9 4C9 2.89543 8.10457 2 7 2C5.89543 2 5 2.89543 5 4C5 4.78871 5.45654 5.47079 6.11978 5.79639L5.53187 14.0271C3.54331 14.2589 2 15.9492 2 18C2 20.2091 3.79086 22 6 22C8.20914 22 10 20.2091 10 18C10 17.5808 9.93553 17.1767 9.81596 16.7971L16.798 13.0375C17.346 13.6294 18.1297 14 19 14C20.6569 14 22 12.6569 22 11C22 9.34315 20.6569 8 19 8C18.1666 8 17.4125 8.33986 16.8689 8.88855L8.97963 4.28651ZM7.61596 5.90335C7.83806 5.83153 8.04316 5.72192 8.22367 5.58209L16.1124 10.1838C16.0392 10.4433 16 10.7171 16 11C16 11.2472 16.0299 11.4873 16.0863 11.7171L9.10396 15.4768C8.57866 14.8314 7.85607 14.3529 7.0281 14.1334L7.61596 5.90335Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetwork);
export default __webpack_public_path__ + "static/media/network.e487fc9ac996561238a9ebe35e04e368.svg";
export { ForwardRef as ReactComponent };